import React, { Component, useEffect, useState } from 'react';
import { observer, inject } from 'mobx-react';

import { Elements, PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import * as JSFUNC from '../../Library/JSFUNC.js';
import * as LibraryReact from '../../Library/LibraryReact.js';
import * as JSPHP from '../../CaptureExecLocalDatabaseMobx/JSPHP.js';
import * as CEGeneralReact from '../../CaptureExecGeneral/CEGeneralReact.js';

import * as CaptureExecReact from '../CaptureExec/CaptureExecReact.js';

//https://stripe.com/docs/payments/quickstart  (turn on the switches at the bottom to see code for automated receipt_email sent to buyer's email address, plus create a stripe customer to save customer details)

//$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
//constant set to switch between using Stripe test mode and live mode keys/products/prices
const stripeLiveModeTrueTestModeFalse = true; //true, false
//$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$

//Stripe public key (make sure to call loadStripe outside of a component’s render to avoid recreating the Stripe object on every render)
var stripeApiKeyPublic = "pk_live_51M7KSjFtGvcbRuR60T4IDPe3Jyjlc2fhZcF7j2OIl9HQu5BM5mOz9mpa9DsyaBIMcmhLWZ2rAQ1G81SWiRdqk8Ip00dTZfkY3i";
if(stripeLiveModeTrueTestModeFalse === false) { //Stripe test mode keys/products/prices
  stripeApiKeyPublic = "pk_test_51M7KSjFtGvcbRuR6vcQD0naZNPlUZibIuJjGk6DsvMX8QeGi1LM8HSmjoTmoIlrYjaXCnuWKrdL9sjyf0jhEZPWw00van70bW8";
}
const stripePromise = loadStripe(stripeApiKeyPublic);

function sgt_is_local_react_development_server() {
  return(document.location.hostname === "localhost" && document.location.port === "3000");
}

export const SamGovTrackerHomepageAdWithLogin = inject("CaptureExecMobx", "SamGovTrackerMobx")(observer(
class SamGovTrackerHomepageAdWithLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      s_actionLogLoopIndex: 0,
      s_loginPanelIsOpenTF: false
    }
  }

  componentDidMount() {
    //after 5 sec on the homepage, trigger the log action command once, by this time, media query flag will have loaded its value
    this.actionLoopID = setInterval(() => this.log_sgt_action_on_first_loop(), 5000);

    if(!sgt_is_local_react_development_server()) {
      this.props.SamGovTrackerMobx.a_load_sgt_product_prices();
      this.props.SamGovTrackerMobx.a_load_testimonials_arrayOfObjs();
    }
  }

  componentWillUnmount() {
    clearInterval(this.actionLoopID);
  }

  log_sgt_action_on_first_loop = () => {
    const s_actionLogLoopIndex = this.state.s_actionLogLoopIndex;
    if(s_actionLogLoopIndex === 1) {
      this.props.SamGovTrackerMobx.a_log_sgt_ad_client_action("sgtHome", "");
    }
    this.setState({s_actionLogLoopIndex:(s_actionLogLoopIndex + 1)});
  }

  onclick_open_login_panel = () => { this.setState({s_loginPanelIsOpenTF:true}); }
  onclick_close_login_panel = () => { this.setState({s_loginPanelIsOpenTF:false}); }

  render() {
    const s_loginPanelIsOpenTF = this.state.s_loginPanelIsOpenTF;

    const c_computedUrlAndProductObj = this.props.CaptureExecMobx.c_computedUrlAndProductObj;
    const c_productStylingObj = this.props.CaptureExecMobx.c_productStylingObj;

    return(
      <>
        <div className="positionFixedFullScreen bgWhite yScroll">
          <div className="displayFlexRow" style={{position:"sticky", top:0, zIndex:1, height:"5.5em", padding:"0 clamp(18px, 5vw, 72px)", borderBottom:"2px solid #d5deeb", background:"#1b3155", boxSizing:"border-box"}}>
            <div
              className="flex00a displayFlexColumnHcVc"
              style={{alignItems:"center", width:"min(250px, calc(100vw - 164px))", height:"100%", padding:"0 24px", boxSizing:"border-box", background:"linear-gradient(90deg, #1b3155 0%, #fff 20%, #fff 80%, #1b3155 100%)"}}>
              <div className="" style={{width:"min(170px, calc(100vw - 220px))"}}>
                <LibraryReact.Image
                  p_src={c_computedUrlAndProductObj.productGraphicsSubfolderAddress + "/samgovtracker16.png"}
                  p_alt={c_productStylingObj.productName}
                  p_styleObj={{width:"100%", height:"auto"}}
                />
              </div>
            </div>
            <div className="flex11a" />
            <div
              className="flex00a displayFlexColumnHcVc textCenter cursorPointer"
              style={{flexBasis:"12em", minWidth:"max-content", padding:"0 0.75em", margin:"0.75em 0", border:"1px solid #8f1b2b", borderTop:"1px solid #ed7c87", borderBottom:"3px solid #8f1b2b", borderRadius:"0.55em", background:"#c6283d", color:"#fff", fontWeight:"700", letterSpacing:"0.02em", whiteSpace:"nowrap", boxShadow:"inset 0 1px 0 rgba(255,255,255,0.28), 0 2px 5px rgba(0,0,0,0.24)", boxSizing:"border-box"}}
              onClick={this.onclick_open_login_panel}>
              <font className="font15 fontWhite">
                {"Customer Login"}
              </font>
            </div>
          </div>
          <SGTHomepageAdContents
            f_onClickLogin={this.onclick_open_login_panel}
          />
        </div>
        {(s_loginPanelIsOpenTF) &&
          <div
            className="positionAbsolute displayFlexColumn"
            style={{zIndex:2, top:0, right:0, bottom:0, width:"95%", maxWidth:"40em", background:"#f3f6fa", boxShadow:"-0.5em 0.5em 1em rgba(20,42,70,0.25)", borderLeft:"1px solid #dbe3ed"}}>
            <div className="positionRelative displayFlexRow" style={{minHeight:"4.5em", padding:"0 1em", background:"#f4f7fb", alignItems:"center"}}>
              <button
                type="button"
                className="flex00a displayFlexColumnHcVc textCenter cursorPointer"
                style={{flexBasis:"2.8em", height:"2.8em", border:0, borderRadius:"50%", background:"#e4ebf3", cursor:"pointer"}}
                aria-label="Close login"
                title="Close Login"
                onClick={this.onclick_close_login_panel}>
                <font className="font20 fontDarkGrayBlueSamGovTracker">
                  {"\u2715"}
                </font>
              </button>
              <div className="flex11a" />
            </div>
            <div
              className={"positionRelative displayFlexColumnHc flex11a yScroll"}
              style={{width:"auto", margin:"1em", padding:"2.5em", border:"1px solid #e2e8f0", borderRadius:"1em", background:"#fff", boxSizing:"border-box"}}>
              <div>
                <LibraryReact.Image
                  p_src={c_computedUrlAndProductObj.productGraphicsSubfolderAddress + "/samgovtracker26.png"}
                  p_alt={c_productStylingObj.productName}
                />
              </div>
              <div className="hugeTopPad" />
              <CaptureExecReact.LoginProcess p_inputTextClass="sgtLoginInput font12" />
            </div>
          </div>
        }
      </>
    );
  }
}));



function SGTHomepageStripePlanCard(props) {
  const p_priceAmount = props.p_priceAmount;
  const p_priceCurrency = props.p_priceCurrency;
  const p_pricesLoadedTF = props.p_pricesLoadedTF;
  const p_featuredTF = props.p_featuredTF === true;
  const priceAvailableTF = p_pricesLoadedTF &&
    typeof p_priceAmount === "number" &&
    p_priceAmount >= 0 &&
    JSFUNC.is_string(p_priceCurrency) &&
    p_priceCurrency !== "";
  const priceText = priceAvailableTF
    ? JSFUNC.stripe_formatted_price_from_amount_and_currency(p_priceAmount, p_priceCurrency)
    : ((p_pricesLoadedTF) ? "Pricing unavailable" : "Loading current price...");

  return(
    <article style={{display:"flex", flexDirection:"column", padding:"clamp(22px, 3vw, 34px)", borderRadius:"14px", border:(p_featuredTF ? "2px solid #0968a8" : "1px solid #d9e2ec"), background:"#fff", boxShadow:(p_featuredTF ? "0 18px 42px rgba(24,65,105,0.14)" : "0 10px 28px rgba(24,65,105,0.08)"), minHeight:"100%", boxSizing:"border-box"}}>
      <div style={{display:"flex", flexWrap:"wrap", justifyContent:"space-between", alignItems:"center", gap:"12px"}}>
        <div style={{minWidth:0, flex:"1 1 180px", color:"#1b3155", fontSize:"1.34rem", fontWeight:"800"}}>{props.p_planName}</div>
        {(p_featuredTF) &&
          <span style={{maxWidth:"100%", boxSizing:"border-box", whiteSpace:"nowrap", background:"#e7f2fb", color:"#0968a8", borderRadius:"999px", padding:"6px 10px", fontSize:"0.73rem", fontWeight:"800", letterSpacing:"0.04em"}}>
            {"WITH FILE STORAGE"}
          </span>
        }
      </div>
      <p style={{minHeight:"3em", margin:"10px 0 0", color:"#52647a", lineHeight:1.5}}>{props.p_planSubtitle}</p>
      <div style={{margin:"18px 0 20px", color:"#1b3155"}}>
        <span style={{fontSize:"2.5rem", fontWeight:"800", letterSpacing:"-0.04em"}}>{priceText}</span>
        {priceAvailableTF &&
          <span style={{marginLeft:"8px", color:"#52647a", fontSize:"0.98rem"}}>
            {"/ user / month"}
          </span>
        }
      </div>
      <ul style={{listStyle:"none", display:"grid", gap:"13px", margin:"0 0 24px", padding:0, color:"#354960", lineHeight:1.45}}>
        {props.p_bulletsTextArray.map((m_text) =>
          <li key={m_text} style={{display:"flex", gap:"10px", alignItems:"flex-start"}}>
            <span aria-hidden="true" style={{color:"#0a7b58", fontWeight:"800"}}>{"\u2713"}</span>
            <span>{m_text}</span>
          </li>
        )}
      </ul>
      <button
        type="button"
        onClick={props.f_onClick}
        style={{marginTop:"auto", minHeight:"50px", border:0, borderRadius:"8px", background:(p_featuredTF ? "#0968a8" : "#1b3155"), color:"#fff", fontSize:"0.94rem", fontWeight:"800", cursor:"pointer"}}>
        {props.p_buttonText}
      </button>
      <div style={{textAlign:"center", color:"#68788c", fontSize:"0.83rem", marginTop:"12px"}}>
        {"Monthly billing \u00b7 no contract \u00b7 cancel anytime"}
      </div>
    </article>
  );
}



export const SamGovTrackerBuySGTProcess = inject("CaptureExecMobx", "SamGovTrackerMobx")(observer(
class SamGovTrackerBuySGTProcess extends Component {
  componentDidMount() {
    this.props.SamGovTrackerMobx.a_log_sgt_ad_client_action("buySGTCustomerInfo", "");

    //immediately on mount, fetch every company code used by existing customers as a comma list
    this.load_all_used_company_codes();

    //in parallel, load the prices of both SGT created product options from the Stripe dashboard using the PHP Stripe API
    if(!sgt_is_local_react_development_server()) {
      this.props.SamGovTrackerMobx.a_load_sgt_product_prices();
    }
  }

  load_all_used_company_codes = () => {
    const jsDescription = JSFUNC.js_description_from_action("SamGovTrackerReact - SamGovTrackerBuySGTProcess", "load_all_used_company_codes", [], []);
    const C_CallPhpScript = new JSPHP.ClassCallPhpScript("loadAllUsedCompanyCodes", jsDescription);
    C_CallPhpScript.add_return_vars("allUsedCompanyCodesComma");

    const functionOnSuccess = (i_parseResponse) => {
      this.props.SamGovTrackerMobx.a_set_all_used_company_codes_comma(i_parseResponse.allUsedCompanyCodesComma);
    }
    C_CallPhpScript.add_function("onSuccess", functionOnSuccess);

    C_CallPhpScript.execute();
  }

  render() {
    const o_mediaQueryFlag = this.props.CaptureExecMobx.o_mediaQueryFlag;
    const c_isMobileTF = this.props.CaptureExecMobx.c_isMobileTF;
    const c_isMobileOrTabletTF = this.props.CaptureExecMobx.c_isMobileOrTabletTF;
    const o_testimonialsArrayOfObjs = this.props.SamGovTrackerMobx.o_testimonialsArrayOfObjs;
    const c_buyProcessStateIsInfoTF = this.props.SamGovTrackerMobx.c_buyProcessStateIsInfoTF;
    const c_buyProcessStateIsCCTF = this.props.SamGovTrackerMobx.c_buyProcessStateIsCCTF;

    const mqf3TF = (o_mediaQueryFlag === 3);

    const backToHomeTopRightComponent = (
      <div className="displayFlexRow smallFullPad">
        <div className="flex11a" />
        <div className="flex00a">
          <SGTBuyBackToHomeLink />
        </div>
      </div>
    );
    
    var outerMarginEm = 3.5;
    var innerPaddingEm = 3.5;
    if(c_isMobileTF) {
      outerMarginEm = 1;
      innerPaddingEm = 1;
    }
    else if(mqf3TF) {
      outerMarginEm = 2;
      innerPaddingEm = 2;
    }

    const leftSideComponent = (
      <div className="border1bbb borderRadius10" style={{background:"#f9f9f9", padding:innerPaddingEm + "em"}}>
        <BuySGTCustomerInfoFormContents />
      </div>
    );

    var rightSideComponent = null;
    if(c_buyProcessStateIsInfoTF) {
      rightSideComponent = (
        <>
          <div className="hugeFullPad textCenter">
            <font className="font25 fontBold fontWhite">
              {"SAM Gov Tracker simplifies & automates capture management for GovCon startups."}
            </font>
          </div>
          <SGTAdTestimonialsCarousel p_testimonialsArrayOfObjs={o_testimonialsArrayOfObjs} p_numTestimonialsDisplayed={1} />
        </>
      );
    }
    else if(c_buyProcessStateIsCCTF) {
      rightSideComponent = (
        <div className="border1bbb borderRadius10 animationFadeIn" style={{background:"#f9f9f9", padding:innerPaddingEm + "em"}}>
          <BuySGTCardTitle>{"Ready To Get Started?"}</BuySGTCardTitle>
          <StripeSubscriptionCheckoutForm />
        </div>
      );
    }

    var buySGTProcessContentsComponent = null;
    if(c_isMobileOrTabletTF) {
      buySGTProcessContentsComponent = (
        <div style={{padding:"0 " + outerMarginEm + "em"}}>
          {leftSideComponent}
          <div style={{paddingTop:"4em"}} />
          {rightSideComponent}
          <div style={{paddingTop:"4em"}} />
        </div>
      );
    }
    else {
      buySGTProcessContentsComponent = (
        <div className="displayFlexColumnHcVc">
          <div className="displayFlexRow" style={{width:"100%", maxWidth:"1300px"}}>
            <div className="flex11a" style={{flexBasis:"100em", padding:"0 " + outerMarginEm + "em"}}>
              {leftSideComponent}
            </div>
            <div className="flex11a" style={{flexBasis:"100em", padding:"0 " + outerMarginEm + "em"}}>
              {rightSideComponent}
            </div>
          </div>
        </div>
      );
    }
    
    return(
      <div className="positionFixedFullScreen sgtAdSection1BgBlueGradient yScroll">
        {backToHomeTopRightComponent}
        {buySGTProcessContentsComponent}
      </div>
    );
  }
}));




const StripeSubscriptionCheckoutForm = inject("SamGovTrackerMobx")(observer(
class StripeSubscriptionCheckoutForm extends Component { //props: 
  constructor(props) {
    super(props);
    this.state = {
      s_stripeSubscriptionPaymentIntentClientSecret: ""
    };
  }

  componentDidMount() {
    const o_customerCompanyName = this.props.SamGovTrackerMobx.o_customerCompanyName;
    const o_customerCompanyCode = this.props.SamGovTrackerMobx.o_customerCompanyCode;
    const o_customerFirstName = this.props.SamGovTrackerMobx.o_customerFirstName;
    const o_customerLastName = this.props.SamGovTrackerMobx.o_customerLastName;
    const o_customerEmail = this.props.SamGovTrackerMobx.o_customerEmail;
    const o_purchaseSGTNumUsers = this.props.SamGovTrackerMobx.o_purchaseSGTNumUsers;
    const o_purchaseSGTProduct = this.props.SamGovTrackerMobx.o_purchaseSGTProduct;
    var customerInfo = "[" + o_customerCompanyCode + "] " + o_customerCompanyName;
    customerInfo += "\n" + o_customerFirstName + " " + o_customerLastName + " (" + o_customerEmail + ")";
    customerInfo += "\n" + o_purchaseSGTProduct + " {" + o_purchaseSGTNumUsers + "}";
    this.props.SamGovTrackerMobx.a_log_sgt_ad_client_action("buySGTStripeCheckout", customerInfo);

    //create a new Customer and a new incomplete Subscription as soon as the component loads by calling sgt_stripe_api.php and storing the returned clientSecret
    this.stripe_create_new_customer_and_incomplete_subscription();
  }

  stripe_create_new_customer_and_incomplete_subscription = () => {
    const o_customerCompanyName = this.props.SamGovTrackerMobx.o_customerCompanyName;
    const o_customerCompanyCode = this.props.SamGovTrackerMobx.o_customerCompanyCode;
    const o_customerFirstName = this.props.SamGovTrackerMobx.o_customerFirstName;
    const o_customerLastName = this.props.SamGovTrackerMobx.o_customerLastName;
    const o_customerEmail = this.props.SamGovTrackerMobx.o_customerEmail;
    const o_purchaseSGTNumUsers = this.props.SamGovTrackerMobx.o_purchaseSGTNumUsers;
    const o_purchaseSGTProduct = this.props.SamGovTrackerMobx.o_purchaseSGTProduct;

    const jsDescription = JSFUNC.js_description_from_action("SamGovTrackerReact - StripeSubscriptionCheckoutForm", "stripe_create_new_customer_and_incomplete_subscription", [], []);
    const C_CallPhpScript = new JSPHP.ClassCallPhpScript("sgt_stripe_api", jsDescription);

    C_CallPhpScript.add_post_var("i_stripeApi", "createNewCustomerAndIncompleteSubscription");
    C_CallPhpScript.add_post_var("i_companyName", o_customerCompanyName);
    C_CallPhpScript.add_post_var("i_companyCode", o_customerCompanyCode);
    C_CallPhpScript.add_post_var("i_customerFirstName", o_customerFirstName);
    C_CallPhpScript.add_post_var("i_customerLastName", o_customerLastName);
    C_CallPhpScript.add_post_var("i_customerEmail", o_customerEmail);
    C_CallPhpScript.add_post_var("i_purchaseSGTProduct", o_purchaseSGTProduct);
    C_CallPhpScript.add_post_var("i_purchaseSGTNumUsers", o_purchaseSGTNumUsers);

    C_CallPhpScript.add_return_vars("clientSecret");
    C_CallPhpScript.add_return_vars("paymentIntentAmount");

    const functionOnSuccess = (i_parseResponse) => {
      this.setState({s_stripeSubscriptionPaymentIntentClientSecret:i_parseResponse.clientSecret});
    }
    C_CallPhpScript.add_function("onSuccess", functionOnSuccess);

    C_CallPhpScript.execute();
  }

  render() {
    const s_stripeSubscriptionPaymentIntentClientSecret = this.state.s_stripeSubscriptionPaymentIntentClientSecret;

    const o_customerEmail = this.props.SamGovTrackerMobx.o_customerEmail;

    if(s_stripeSubscriptionPaymentIntentClientSecret === "") {
      return(
        <div className="bigTopMargin textCenter">
          <font className="font11 fontDarkGrayBlueSamGovTracker">
            {"Establishing a secure connection..."}
          </font>
        </div>
      );
    }

    //appearance options (within Elements options input) https://stripe.com/docs/elements/appearance-api
    const stripeElementsOptionsAppearanceObj = {
      theme: 'stripe'
    };

    //Elements options input (client secret string fetched from server required) https://stripe.com/docs/js/elements_object/create#stripe_elements-options
    const stripeElementsOptionsObj = {
      clientSecret: s_stripeSubscriptionPaymentIntentClientSecret,
      appearance: stripeElementsOptionsAppearanceObj
    };

    return(
      <Elements stripe={stripePromise} options={stripeElementsOptionsObj}>
        <StripeCheckoutFormAndPayButtonWithSuccessURLRedirect i_receiptEmail={o_customerEmail} />
      </Elements>
    );
  }
}));



function StripeCheckoutFormAndPayButtonWithSuccessURLRedirect({i_receiptEmail}) {
  const stripe = useStripe();
  const elements = useElements();

  const [messageOrNull, f_setMessage] = useState(null);
  const [isLoadingTF, f_setIsLoadingTF] = useState(false);

  //effect for when useStripe() stripe obj changes status
  useEffect(() => {
    if(!stripe) {
      return;
    }

    const paymentIntentClientSecretFromUrlVar = new URLSearchParams(window.location.search).get("payment_intent_client_secret");

    if(!paymentIntentClientSecretFromUrlVar) {
      return;
    }

    stripe.retrievePaymentIntent(paymentIntentClientSecretFromUrlVar).then(({ paymentIntent }) => {
      switch(paymentIntent.status) {
        case "succeeded":
          f_setMessage("Payment succeeded!");
          break;
        case "processing":
          f_setMessage("Your payment is processing.");
          break;
        case "requires_payment_method":
          f_setMessage("Your payment was not successful, please try again.");
          break;
        default:
          f_setMessage("Something went wrong.");
          break;
      }
    });
  }, [stripe]);

  //[https://stripe.com/docs/payments/quickstart]
  // - When your customer clicks the pay button, call stripe.confirmPayment() with the PaymentElement and pass a return_url to indicate where Stripe should redirect the user after they complete the payment.
  // - For payments that require authentication, Stripe displays a modal for 3D Secure authentication or redirects the customer to an authentication page depending on the payment method.
  // - After the customer completes the authentication process, they’re redirected to the return_url.
  const functionOnSubmitPaymentForm = async (event) => {
    event.preventDefault();

    //Stripe.js has not yet loaded. Make sure to disable form submission until Stripe.js has loaded.
    if(!stripe || !elements) {
      return;
    }

    f_setIsLoadingTF(true);

    //redirects page to https://samgovtracker.com/php/sgt_signup_success.php?payment_intent=pi_3MHlRHFtGvcbRuR61R8NrEng&payment_intent_client_secret=pi_3MHlRHFtGvcbRuR61R8NrEng_secret_ZbJDdoPONiSFS1Xka3e0fh6sK&redirect_status=succeeded
    // - payment_intent=pi_3MHlRHFtGvcbRuR61R8NrEng
    // - payment_intent_client_secret=pi_3MHlRHFtGvcbRuR61R8NrEng_secret_ZbJDdoPONiSFS1Xka3e0fh6sK
    // - redirect_status=succeeded
    //it is mandatory for return_url to be set and to redirect to that page with the added URL vars, otherwise the Subscription Payment remains as 'incomplete'
    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: "https://samgovtracker.com/php/sgt_signup_success.php",
        receipt_email: i_receiptEmail,
      }
    });

    //This point will only be reached if there is an immediate error when confirming the payment. Otherwise, your customer will be redirected to your `return_url`.
    //For some payment methods like iDEAL, your customer will be redirected to an intermediate site first to authorize the payment, then redirected to the `return_url`.
    if((error.type === "card_error") || (error.type === "validation_error")) {
      f_setMessage(error.message);
    }
    else {
      f_setMessage("An unexpected error occurred.");
    }

    f_setIsLoadingTF(false);
  };

  const stripePaymentElementOptionsObj = {
    layout: "tabs"
  }

  const payButtonIsDisabledTF = (isLoadingTF || !stripe || !elements);

  return(
    <form id="payment-form" onSubmit={functionOnSubmitPaymentForm}>
      <PaymentElement id="payment-element" options={stripePaymentElementOptionsObj} />
      <div className="medTopMargin" />
      <button
        id="submit"
        disabled={payButtonIsDisabledTF}
        className="border bevelBorderColors borderRadius05 bgRedGradientSamGovTracker hoverLightRedGradientSamGovTracker fontBold fontWhite cursorPointer"
        style={{width:"10em", height:"2.5em"}}>
        <span id="button-text">
          {(isLoadingTF) ? (
            <div id="spinner" className="spinner" />
          ) : (
            "Pay Now"
          )}
        </span>
      </button>
      {(messageOrNull) && 
        <div id="payment-message" className="smallTopMargin">
          <div className="font11 fontDarkGrayBlueSamGovTracker">
            {messageOrNull}
          </div>
        </div>
      }
    </form>
  );
}




//^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
//^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^



const SGTHomepageAdContents = inject("CaptureExecMobx", "SamGovTrackerMobx")(observer(
class SGTHomepageAdContents extends Component { //props: f_onClickLogin
  constructor(props) {
    super(props);
    this.state = {
      s_selectedFeaturesTabIndex: 0
    };
  }

  onclick_sgt_sign_up_now = () => {
    this.props.CaptureExecMobx.a_set_login_state("sgtBuySgtEnterInfo");
  }

  onclick_features_tab = (i_featuresTabIndex) => {
    this.setState({s_selectedFeaturesTabIndex:i_featuresTabIndex});
  }

  onclick_choose_sgt_plan = (i_product) => {
    this.props.SamGovTrackerMobx.a_set_purchase_sgt_product(i_product);
    this.props.CaptureExecMobx.a_set_login_state("sgtBuySgtEnterInfo");
  }

  render () {
    const s_selectedFeaturesTabIndex = this.state.s_selectedFeaturesTabIndex;

    const o_mediaQueryFlag = this.props.CaptureExecMobx.o_mediaQueryFlag;
    const c_isMobileTF = this.props.CaptureExecMobx.c_isMobileTF;
    const c_isMobileOrTabletTF = this.props.CaptureExecMobx.c_isMobileOrTabletTF;
    const c_computedUrlAndProductObj = this.props.CaptureExecMobx.c_computedUrlAndProductObj;
    const o_testimonialsArrayOfObjs = this.props.SamGovTrackerMobx.o_testimonialsArrayOfObjs;
    const o_sgtNoDocsPriceAmount = this.props.SamGovTrackerMobx.o_sgtNoDocsPriceAmount;
    const o_sgtNoDocsPriceCurrency = this.props.SamGovTrackerMobx.o_sgtNoDocsPriceCurrency;
    const o_sgtWithDocsPriceAmount = this.props.SamGovTrackerMobx.o_sgtWithDocsPriceAmount;
    const o_sgtWithDocsPriceCurrency = this.props.SamGovTrackerMobx.o_sgtWithDocsPriceCurrency;
    const o_sgtProductPricesLoadedTF = this.props.SamGovTrackerMobx.o_sgtProductPricesLoadedTF ||
      sgt_is_local_react_development_server();

    const mqf3TF = (o_mediaQueryFlag === 3);
    const nowYearInt = JSFUNC.now_year_int();

    const sgtWebsiteAssetRoot = "https://bitsolutionsllc.com/wp-content/uploads/2026/05/";
    const section1FootprintsTaglinesComponent = (
      <div style={{display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(290px, 1fr))", gap:"clamp(28px, 5vw, 72px)", alignItems:"center", maxWidth:"1280px", margin:"0 auto", padding:"clamp(40px, 7vw, 92px) clamp(18px, 5vw, 64px) 42px"}}>
        <div>
          <div style={{color:"#1267a1", fontSize:"0.82rem", fontWeight:"800", letterSpacing:"0.14em", textTransform:"uppercase", marginBottom:"1em"}}>
            {"Capture management for growing GovCon teams"}
          </div>
          <h1 style={{fontSize:"clamp(2.7rem, 5vw, 4.7rem)", lineHeight:1.02, color:"#1b3155", margin:"0 0 0.3em", letterSpacing:"-0.045em"}}>
            {"Simplified Capture Management"}
          </h1>
          <p style={{fontSize:"1.18rem", lineHeight:1.65, color:"#42536a", maxWidth:"38em", margin:"0 0 1.5em"}}>
            {"A capture management solution for startups, micro, and small government contractors. Find opportunities that align with your expertise."}
          </p>
          <div style={{display:"flex", flexWrap:"wrap", gap:"12px", alignItems:"center"}}>
            <a href="#sgtplans" style={{display:"inline-flex", alignItems:"center", justifyContent:"center", minHeight:"48px", padding:"0 22px", borderRadius:"8px", background:"#0968a8", color:"#fff", fontWeight:"700", textDecoration:"none"}}>
              {"Choose your plan"}
            </a>
            <button type="button" onClick={this.props.f_onClickLogin} style={{minHeight:"48px", padding:"0 22px", border:"1px solid #c8d3e0", borderRadius:"8px", background:"#fff", color:"#1b3155", fontWeight:"700", cursor:"pointer"}}>
              {"Customer login"}
            </button>
          </div>
          <div style={{display:"flex", flexWrap:"wrap", gap:"18px", marginTop:"24px", color:"#52647a", fontSize:"0.94rem"}}>
            <span>{"No binding contract"}</span>
            <span>{"Cancel anytime"}</span>
            <span>{"Built for small contractors"}</span>
          </div>
        </div>
        <div style={{borderRadius:"18px", overflow:"hidden", boxShadow:"0 22px 55px rgba(26,54,91,0.16)", background:"#eaf1f8"}}>
          <img src={sgtWebsiteAssetRoot + "Simplified-capture-management.webp"} alt="SAM Gov Tracker capture management dashboard" style={{display:"block", width:"100%", height:"auto"}} />
        </div>
      </div>
    );

    //section 1 - two products
    const productBoxSGTComponent = (
      <SGTHomepageStripePlanCard
        p_planName="SAM Gov Tracker"
        p_planSubtitle="Capture management essentials"
        p_priceAmount={o_sgtNoDocsPriceAmount}
        p_priceCurrency={o_sgtNoDocsPriceCurrency}
        p_pricesLoadedTF={o_sgtProductPricesLoadedTF}
        p_bulletsTextArray={["Search and save SAM.gov opportunities", "Import opportunities into your capture pipeline", "Track stages, milestones, and team activity"]}
        p_buttonText="Start with the essentials"
        f_onClick={() => this.onclick_choose_sgt_plan("sgtNoDocs")}
      />
    );

    const productBoxCEComponent = (
      <SGTHomepageStripePlanCard
        p_planName="SAM Gov Tracker + Documents"
        p_planSubtitle="Everything in the core plan, plus file storage"
        p_priceAmount={o_sgtWithDocsPriceAmount}
        p_priceCurrency={o_sgtWithDocsPriceCurrency}
        p_pricesLoadedTF={o_sgtProductPricesLoadedTF}
        p_featuredTF={true}
        p_bulletsTextArray={["Upload and organize local capture documents", "Share proposal and strategy files with your team", "Keep opportunity records and working files together"]}
        p_buttonText="Choose the documents plan"
        f_onClick={() => this.onclick_choose_sgt_plan("sgtWithDocs")}
      />
    );

    const section1ProductsComponent = (
      <div style={{display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(280px, 1fr))", gap:"22px", width:"100%", maxWidth:"1050px", margin:"0 auto"}}>
        {productBoxSGTComponent}
        {productBoxCEComponent}
      </div>
    );

    //section 1 - tagline
    var section1TaglinePadding = "0.5em 0";
    if(c_isMobileTF) {
      section1TaglinePadding = "0 10%";
    }
    else if(c_isMobileOrTabletTF) {
      section1TaglinePadding = "0.5em 5%";
    }
    else if(mqf3TF) {
      section1TaglinePadding = "0.5em 0";
    }

    const section1TaglineComponent = (
      <div style={{maxWidth:"850px", margin:"clamp(44px, 7vw, 88px) auto 0", padding:section1TaglinePadding, textAlign:"center"}}>
        <div style={{color:"#1267a1", fontSize:"0.82rem", fontWeight:"800", letterSpacing:"0.13em", textTransform:"uppercase", marginBottom:"12px"}}>
          {"From discovery to proposal"}
        </div>
        <h2 style={{fontSize:"clamp(1.8rem, 3vw, 2.8rem)", lineHeight:1.15, color:"#1b3155", margin:0}}>
          {"A repeatable capture process, without the spreadsheet scramble."}
        </h2>
        <p style={{fontSize:"1.08rem", lineHeight:1.7, color:"#52647a", margin:"16px auto 0", maxWidth:"42em"}}>
          {"Find opportunities that fit, organize your pipeline, coordinate your team, and keep key dates and documents in reach."}
        </p>
      </div>
    );
    
    //section 2 - bullets hat
    var section2BulletsComponent = (
      <>
        <div className="" style={{marginBottom:"25px"}}>
          <font className="font30">
            {"SAM Gov Tracker "}<font className="fontBold">{"makes SAM.gov work for you"}</font>
          </font>
        </div>
        <SGTAdProductBoxBulletList
          p_bulletsTextArray={["SAM.gov is difficult to use", "SAM.gov cannot manage your Captures", "Your current Pipeline list/spreadsheet needs to be manually updated", "Multiple users lose data updates on pipeline spreadsheet", "Your process is not a repeatable Sales workflow", "You miss deadlines for RFPs and other information"]}
          p_fontClass="font16"
        />
      </>
    );

    var section2BulletsHatComponent = null;
    if(c_isMobileOrTabletTF) {
      section2BulletsHatComponent = (
        <>
          <div className="displayFlexColumnHcVc">
            <SGTAdHatPicture />
          </div>
          <div style={{padding:"10%"}}>
            {section2BulletsComponent}
          </div>
        </>
      );
      
    }
    else {
      section2BulletsHatComponent = (
        <div className="displayFlexRow">
          <div className="flex11a" style={{flexBasis:"100em", paddingLeft:"4em"}}>
            {section2BulletsComponent}
          </div>
          <div className="flex11a displayFlexColumnHcVc" style={{flexBasis:"100em"}}>
            <SGTAdHatPicture />
          </div>
        </div>
      );
    }

    //section 2 - scrolling screenshots
    const section2ScrollingScreenshotsTopTaglineComponent = (
      <div className="lrMedPad textCenter">
        <font className={((c_isMobileTF) ? ("font25") : ("font30"))}>
          <font className="fontBold">{"Capture management gets done "}</font>{"with SAM Gov Tracker"}
        </font>
      </div>
    );

    const section2ScrollingScreenshot1WinMoreBids = (
      <SGTAdLRScreenshotAndTagline
        p_horizontalTrueVerticalFalse={(!c_isMobileOrTabletTF)}
        p_screenshotLeftTrueRightFalse={true}
        p_screenshotSrc={sgtWebsiteAssetRoot + "Win-10x-More-Bids.webp"}
        p_screenshotMaxWidth="540px"
        p_screenshotAlt="SAM Gov Tracker Screenshot - Win 10x More Bids"
        p_taglineTitle="Win 10x More Bids"
        p_taglineBulletsTextArray={["Auto-import opportunities with 1 click", "See opportunity intel at-a-glance", "Track every detail"]}
      />
    );

    const section2ScrollingScreenshot2NoMoreSpreadsheets = (
      <SGTAdLRScreenshotAndTagline
        p_horizontalTrueVerticalFalse={(!c_isMobileOrTabletTF)}
        p_screenshotLeftTrueRightFalse={false}
        p_screenshotSrc={c_computedUrlAndProductObj.productGraphicsSubfolderAddress + "/sgtad_screenshot_section2_2middle_no_more_spreadsheets.png"}
        p_screenshotAlt="SAM Gov Tracker Screenshot - No More Spreadsheets"
        p_taglineTitle="No More Spreadsheets"
        p_taglineBulletsTextArray={["Organize captures by various fields", "Click-and-drag to advance through stages"]}
      />
    );

    const section2ScrollingScreenshot3IncreaseEfficiency = (
      <SGTAdLRScreenshotAndTagline
        p_horizontalTrueVerticalFalse={(!c_isMobileOrTabletTF)}
        p_screenshotLeftTrueRightFalse={true}
        p_screenshotSrc={sgtWebsiteAssetRoot + "Increase-Efficiency-100x.webp"}
        p_screenshotMaxWidth="540px"
        p_screenshotAlt="SAM Gov Tracker Screenshot - Increase Efficiency 100x"
        p_taglineTitle="Increase Efficiency 100x"
        p_taglineBulletsTextArray={["Log every event date & milestone", "Auto-task team members", "Share docs in central hub"]}
      />
    );

    //section 3 - start now call to action
    const section3StartNowLeftTextComponent = (
      <div className="textCenter">
        <font className={((c_isMobileOrTabletTF) ? ("font25") : ("font35")) + " fontWhite"}>
          <div>{"Start with"}</div>
          <LibraryReact.DivFont p_fontClass="fontBold">{"SAM Gov Tracker Now!"}</LibraryReact.DivFont>
        </font>
      </div>
    );

    const section3StartNowRightActionButtonComponent = (
      <>
        <div className="textCenter">
          <font className="font15 fontWhite">
            {"Accelerate your time, efficiency, and wins using SAM Gov Tracker!"}
          </font>
        </div>
        <div style={{width:"30em", marginTop:"5px"}}>
          <SGTAdProductActionButton
            p_product="samgovtracker"
            p_buttonText={"Get Started \u2192"}
          />
        </div>
      </>
    );

    var section3StartNowCallToActionWithButtonComponent = null;
    if(c_isMobileOrTabletTF) {
      section3StartNowCallToActionWithButtonComponent = (
        <div className="displayFlexColumnHcVc" style={{margin:"0 5%"}}>
          {section3StartNowLeftTextComponent}
          <div style={{paddingTop:"2em"}} />
          {section3StartNowRightActionButtonComponent}
        </div>
      );
    }
    else {
      section3StartNowCallToActionWithButtonComponent = (
        <div className="displayFlexRow">
          <div className="flex11a displayFlexColumnHcVc" style={{flexBasis:"100em"}}>
            {section3StartNowLeftTextComponent}
          </div>
          <div className="flex11a displayFlexColumnHcVc" style={{flexBasis:"100em"}}>
            {section3StartNowRightActionButtonComponent}
          </div>
        </div>
      );
    }
    

    //section 3 - devices containing screenshots
    const maxWidthPx = 1700;
    const heightWidthRatio = 0.55;
    const section3DevicesComponent = (
      <div className="displayFlexColumnHcVc">
        <div className="positionRelative" style={{width:"100%", maxWidth:maxWidthPx + "px", height:(100 * heightWidthRatio) + "vw", maxHeight:(maxWidthPx * heightWidthRatio) + "px"}}>
          <div className="positionAbsolute" style={{bottom:"19%", left:"3%", height:"80%"}}>
            <LibraryReact.Image p_src={c_computedUrlAndProductObj.productGraphicsSubfolderAddress + "/sgtad_devices_laptop.png"} p_alt="SAM Gov Tracker on Device - Laptop" p_styleObj={{height:"100%"}} />
          </div>
          <div className="positionAbsolute" style={{bottom:"-13%", left:"52%", height:"83%"}}>
            <LibraryReact.Image p_src={c_computedUrlAndProductObj.productGraphicsSubfolderAddress + "/sgtad_devices_tablet.png"} p_alt="SAM Gov Tracker on Device - Tablet" p_styleObj={{height:"100%"}} />
          </div>
          <div className="positionAbsolute" style={{bottom:"0", left:"1%", height:"75%"}}>
            <LibraryReact.Image p_src={c_computedUrlAndProductObj.productGraphicsSubfolderAddress + "/sgtad_devices_mobile.png"} p_alt="SAM Gov Tracker on Device - Mobile" p_styleObj={{height:"100%"}} />
          </div>
        </div>
      </div>
    );

    //section 4 - features tabs
    const featuresTabsTagLineComponent = (
      <div className="textCenter" style={{margin:"0 5%"}}>
        <font className="font24">
          {"Manage your captures "}<font className="fontBold">{"seamlessly & effortlessly"}</font>
        </font>
      </div>
    );

    var featuresTabsArrayOfObjs = [
      {
        tabName: "Search SAM",
        title: "Search SAM.gov from within the system",
        text: "Conduct searches directly within the system based on a series of parameters you choose. Gone are the days of manually navigating the government website.",
        gifFileNameAndExt: "sgtad_featurestab1_search_sam.gif"
      },
      {
        tabName: "Save Searches",
        title: "Save unlimited favorite searches",
        text: "Set favorite search parameters and save them for future use, cutting down opportunity identification time tenfold. Tailor your favorite searches to your core business areas, prime opportunities, subcontract opportunities, or whatever else makes sense for your company.",
        gifFileNameAndExt: "sgtad_featurestab2_save_searches.gif"
      },
      {
        tabName: "1-click Import",
        title: "One-click import of all SAM data",
        text: "Once your search criteria is set and opportunities that meet that criteria are identified, ingest them into the system and automatically add them to your Capture Table. One click is all it takes!",
        gifFileNameAndExt: "sgtad_featurestab3_1click_import.gif"
      },
      {
        tabName: "Track Deals",
        title: "Track each deal through stages from Prospect to Win!",
        text: "Track exactly where all of your captures are in the process with the Stages function, which allows you to sort by stages and gauge the overall health of your pipeline. No more manual, tedious sorting in Excel or developing confusing macros!",
        gifFileNameAndExt: "sgtad_featurestab4_track_deals.gif"
      },
      {
        tabName: "Manage Dates",
        title: "Manage important upcoming dates",
        text: "Don't lose track of important proposal dates or milestones. You know the feeling - a proposal date came and went and you forgot all about it. With SGT, you'll never feel that way again!",
        gifFileNameAndExt: "sgtad_featurestab5_manage_dates.gif"
      },
      {
        tabName: "Auto Reminders",
        title: "Collaborate across Sales team including Notepad information and Delegated Tasks with auto reminder",
        text: "Share notes across your team from one central location, and manage tasks using automatic reminders and notifications. Never miss a beat with SGT when you're collaborating on a capture!",
        gifFileNameAndExt: "sgtad_featurestab6_auto_reminders.gif"
      },
      {
        tabName: "Store Documents",
        title: "Stay organized by uploading Documents directly to each Opportunity",
        text: "Stay organized and current by uploading documents to each respective capture entry. SGT eliminates all that wasted time emailing documents around or scrambling for a link to the document folder.",
        gifFileNameAndExt: "sgtad_featurestab7_store_documents.gif"
      },
      {
        tabName: "Manage Admins",
        title: "Self managed number of users (Administrators or Capture Managers)",
        text: "Keep track of and assign roles from a central hub for all of your SGT users and contributors.",
        gifFileNameAndExt: "sgtad_featurestab8_manage_admins.gif"
      }
    ];

    const tabDbNamesArray = JSFUNC.array_fill_incrementing_0_to_nm1(featuresTabsArrayOfObjs.length);
    const tabDisplayNamesArray = JSFUNC.get_column_vector_from_arrayOfObjs(featuresTabsArrayOfObjs, "tabName");

    const featuresTabsComponent = (
      <div className="displayFlexColumnHcVc smallFullPad">
        <CEGeneralReact.TabsList
          p_tabDbNamesArray={tabDbNamesArray}
          p_tabDisplayNamesArray={tabDisplayNamesArray}
          p_selectedTabDbName={s_selectedFeaturesTabIndex}
          p_tabHeight="3.3em"
          p_textMaxHeight="3em"
          p_tabWidth={((c_isMobileOrTabletTF) ? ("7em") : ("12em"))}
          p_selectedBgClass="bgCstColumnHeaderSamGovTracker"
          p_selectedFontClass="font11 fontWhite"
          p_unselectedBgClass="bgLightGray"
          p_unselectedFontClass="font11"
          p_rowFlexWrapTF={true}
          p_borderRadiusClass=""
          f_onSelect={this.onclick_features_tab}
        />
      </div>
    );
    
    var selectedFeaturesTabObj = {};
    if(featuresTabsArrayOfObjs[s_selectedFeaturesTabIndex] !== undefined) {
      selectedFeaturesTabObj = featuresTabsArrayOfObjs[s_selectedFeaturesTabIndex];
    }

    const selectedFeaturesTabGifImageComponent = (
      <LibraryReact.Image
        p_src={c_computedUrlAndProductObj.productGraphicsSubfolderAddress + "/" + selectedFeaturesTabObj.gifFileNameAndExt}
        p_alt={"SAM Gov Tracker Features - " + selectedFeaturesTabObj.tabName}
        p_styleObj={{width:"95%", maxWidth:"800px"}}
      />
    );

    var section4FeaturesTabsComponent = null;
    if(c_isMobileOrTabletTF) {
      section4FeaturesTabsComponent = (
        <>
          {featuresTabsTagLineComponent}
          <div style={{paddingTop:"50px"}} />
          {featuresTabsComponent}
          <div style={{paddingTop:"50px"}} />
          <div className="" style={{margin:"0 5%"}}>
            <div className="">
              <font className="font22">
                {selectedFeaturesTabObj.title}
              </font>
            </div>
            <div className="hugeTopPad">
              <font className="font16">
                {selectedFeaturesTabObj.text}
              </font>
            </div>
          </div>
          <div style={{paddingTop:"50px"}} />
          <div className="displayFlexColumnHcVc">
            {selectedFeaturesTabGifImageComponent}
          </div>
        </>
      );
    }
    else {
      section4FeaturesTabsComponent = (
        <>
          {featuresTabsTagLineComponent}
          <div style={{paddingTop:"50px"}} />
          {featuresTabsComponent}
          <div style={{paddingTop:"50px"}} />
          <div className="displayFlexRow">
            <div className="flex11a displayFlexColumnHcVc" style={{flexBasis:"125em"}}>
              {selectedFeaturesTabGifImageComponent}
            </div>
            <div className="flex11a displayFlexColumnHcVc" style={{flexBasis:"100em"}}>
              <div className="flex00a" style={{width:"90%"}}>
                <div className="">
                  <font className="font22">
                    {selectedFeaturesTabObj.title}
                  </font>
                </div>
                <div className="hugeTopPad">
                  <font className="font16">
                    {selectedFeaturesTabObj.text}
                  </font>
                </div>
              </div>
            </div>
          </div>
        </>
      );
    }
    

    //section 5 - testimonials
    var testimonialsContainerMaxWidthEm = 120;
    var numTestimonialsDisplayed = 3;
    if(c_isMobileOrTabletTF || mqf3TF) {
      testimonialsContainerMaxWidthEm = 40;
      numTestimonialsDisplayed = 1;
    }

    const section5TestimonialsComponent = (
      <div className="displayFlexColumnHcVc">
        <div style={{width:"100%", maxWidth:testimonialsContainerMaxWidthEm + "em"}}>
          <SGTAdTestimonialsCarousel p_testimonialsArrayOfObjs={o_testimonialsArrayOfObjs} p_numTestimonialsDisplayed={numTestimonialsDisplayed} />
        </div>
      </div>
    );

    //section 6 - footer
    var footerAboutText = "BIT Solutions LLC is the ";
    footerAboutText += '"good guy"';
    footerAboutText += " in the industry, leveraging over 25 years of government contracting experience and know-how into its capture and proposal management software products. BIT is a father-son team that started with a mission to look out for the ";
    footerAboutText += '"“little guy"';
    footerAboutText += " and hasn't stopped since!";
    const footerLeftLogoAndAboutComponent = (
      <>
        <LibraryReact.Image p_src={c_computedUrlAndProductObj.productGraphicsSubfolderAddress + "/samgovtracker28.png"} p_alt="SAM Gov Tracker Logo" />
        <div style={{paddingTop:"2em"}}>
          <font className="font15 fontDarkGrayBlueSamGovTracker">
            {footerAboutText}
          </font>
        </div>
      </>
    );

    const footerQuickLinksComponent = (
      <>
        <SGTAdFooterLabel>{"Quick Links"}</SGTAdFooterLabel>
        <SGTAdFooterQuickLink p_text="Sign Up Now!" f_onClick={this.onclick_sgt_sign_up_now} />
        <SGTAdFooterQuickLink p_text="Login" f_onClick={this.props.f_onClickLogin} />
        <SGTAdFooterQuickLink p_text="Why SAM Gov Tracker" p_scrollToElementID="whysamgovtracker" />
        <SGTAdFooterQuickLink p_text="Benefits" p_scrollToElementID="benefits" />
        <SGTAdFooterQuickLink p_text="Features" p_scrollToElementID="features" />
        <SGTAdFooterQuickLink p_text="Testimonials" p_scrollToElementID="testimonials" />
      </>
    );

    const footerSocialMediaComponent = (
      <>
        <SGTAdFooterLabel>{"Social Media"}</SGTAdFooterLabel>
        <SGTAdFooterSocialMediaLink p_text="LinkedIn" p_href="https://www.linkedin.com/company/bitsolutionsllc/" />
        <SGTAdFooterSocialMediaLink p_text="Facebook" p_href="https://www.facebook.com/bitsolutionsllc" />
        <SGTAdFooterSocialMediaLink p_text="Twitter" p_href="https://twitter.com/bitsolutionsllc" />
      </>
    );

    const footerContactComponent = (
      <>
        <SGTAdFooterLabel>{"Contact"}</SGTAdFooterLabel>
        <div className="" style={{paddingBottom:"5px"}}>
          <font className="font14 fontDarkGrayBlueSamGovTracker">
            {"BIT Solutions, LLC"}
          </font>
        </div>
        <div className="" style={{paddingBottom:"5px"}}>
          <font className="font14 fontDarkGrayBlueSamGovTracker">
            <font className="fontBold">{"Email: "}</font><a href="mailto:info@bitsolutionsllc.com">{"info@bitsolutionsllc.com"}</a>
          </font>
        </div>
        <div className="" style={{paddingBottom:"5px"}}>
          <font className="font14 fontDarkGrayBlueSamGovTracker">
            <font className="fontBold">{"Phone: "}</font>{"(410) 925-0424"}
          </font>
        </div>
      </>
    );

    const footerCopyrightComponent = (
      <div className="displayFlexColumnHcVc textCenter">
        <font className="font11 fontBold fontDarkGrayBlueSamGovTracker">
          {"© " + nowYearInt + " BIT Solutions, LLC."}
        </font>
      </div>
    );
    
    var footerComponent = null;
    if(c_isMobileOrTabletTF) {
      footerComponent = (
        <div className="" style={{margin:"0 " + ((c_isMobileTF) ? ("5%") : ("15%"))}}>
          {footerLeftLogoAndAboutComponent}
          <div style={{paddingTop:"2em"}} />
          {footerQuickLinksComponent}
          <div style={{paddingTop:"2em"}} />
          {footerSocialMediaComponent}
          <div style={{paddingTop:"2em"}} />
          {footerContactComponent}
        </div>
      );
    }
    else {
      const mqfGt4TF = (o_mediaQueryFlag > 4);
      footerComponent = (
        <div className="displayFlexRow">
          <div className="flex11a" style={{flexBasis:((mqfGt4TF) ? ("150em") : ("250em")), padding:"0 4em"}}>
            {footerLeftLogoAndAboutComponent}
          </div>
          {(mqfGt4TF) && <div className="flex11a" style={{flexBasis:"100em"}} />}
          <div className="flex11a" style={{flexBasis:"100em"}}>
            {footerQuickLinksComponent}
          </div>
          <div className="flex11a" style={{flexBasis:"100em"}}>
            {footerSocialMediaComponent}
          </div>
          <div className="flex11a" style={{flexBasis:"100em"}}>
            {footerContactComponent}
          </div>
        </div>
      );
    }

    return(
      <>
        <div id="whysamgovtracker" style={{background:"#fff"}}>
          {section1FootprintsTaglinesComponent}
          <section id="sgtplans" style={{padding:"0 clamp(18px, 5vw, 64px) clamp(48px, 7vw, 88px)", scrollMarginTop:"6em"}}>
            <div style={{maxWidth:"1050px", margin:"0 auto 26px", textAlign:"center"}}>
              <div style={{color:"#bd2429", fontSize:"0.82rem", fontWeight:"800", letterSpacing:"0.13em", textTransform:"uppercase"}}>
                {"Straightforward pricing"}
              </div>
              <h2 style={{fontSize:"clamp(1.9rem, 3.5vw, 2.8rem)", color:"#1b3155", margin:"10px 0"}}>
                {"Choose the support your team needs"}
              </h2>
              <p style={{color:"#52647a", fontSize:"1.05rem", lineHeight:1.6, margin:"0 auto", maxWidth:"45em"}}>
                {"Start finding winnable deals in minutes. Both plans are billed monthly, with no binding contract and the freedom to cancel anytime."}
              </p>
            </div>
            {section1ProductsComponent}
          </section>
          <div style={{maxWidth:"1280px", margin:"0 auto", padding:"0 clamp(18px, 5vw, 64px) clamp(48px, 7vw, 90px)"}}>
            {section1TaglineComponent}
          </div>
        </div>

        <section style={{background:"#f3f7fb", padding:"clamp(48px, 7vw, 88px) clamp(18px, 5vw, 64px)"}}>
          <div style={{maxWidth:"1220px", margin:"0 auto"}}>
            {section2BulletsHatComponent}
          </div>
        </section>

        <section id="benefits" style={{background:"#fff", padding:"clamp(48px, 7vw, 88px) clamp(18px, 5vw, 64px)", scrollMarginTop:"6em"}}>
          <div style={{maxWidth:"1320px", margin:"0 auto"}}>
            {section2ScrollingScreenshotsTopTaglineComponent}
            <div style={{height:"34px"}} />
            {section2ScrollingScreenshot1WinMoreBids}
            <div style={{height:"56px"}} />
            {section2ScrollingScreenshot2NoMoreSpreadsheets}
            <div style={{height:"56px"}} />
            {section2ScrollingScreenshot3IncreaseEfficiency}
          </div>
        </section>

        <section style={{background:"#18365d", padding:"clamp(48px, 7vw, 88px) clamp(18px, 5vw, 64px)", color:"#fff"}}>
          <div style={{maxWidth:"1320px", margin:"0 auto"}}>
            {section3StartNowCallToActionWithButtonComponent}
            <div style={{height:"clamp(40px, 7vw, 96px)"}} />
            {section3DevicesComponent}
          </div>
        </section>

        <section id="features" style={{background:"#f3f7fb", padding:"clamp(48px, 7vw, 88px) clamp(18px, 5vw, 64px)", scrollMarginTop:"6em"}}>
          <div style={{maxWidth:"1320px", margin:"0 auto"}}>
            {section4FeaturesTabsComponent}
          </div>
        </section>

        <section id="testimonials" style={{background:"#18365d", padding:"clamp(48px, 7vw, 88px) clamp(18px, 5vw, 64px)", scrollMarginTop:"6em"}}>
          <div style={{maxWidth:"1320px", margin:"0 auto"}}>
            <div style={{textAlign:"center", color:"#fff", marginBottom:"34px"}}>
              <div style={{fontSize:"0.82rem", fontWeight:"800", letterSpacing:"0.13em", textTransform:"uppercase", color:"#b8d7f2"}}>
                {"Built around real capture teams"}
              </div>
              <h2 style={{fontSize:"clamp(1.9rem, 3vw, 2.7rem)", margin:"10px 0 0", color:"#fff"}}>
                {"A more confident way to pursue the right work"}
              </h2>
            </div>
            {section5TestimonialsComponent}
            <div style={{height:"clamp(48px, 6vw, 80px)"}} />
            {section3StartNowCallToActionWithButtonComponent}
          </div>
        </section>

        <footer style={{background:"#f3f7fb", padding:"clamp(42px, 6vw, 76px) clamp(18px, 5vw, 64px) 18px"}}>
          <div style={{maxWidth:"1320px", margin:"0 auto"}}>
            {footerComponent}
            <div style={{height:"52px"}} />
            {footerCopyrightComponent}
          </div>
        </footer>
      </>
    );
  }
}));

function SGTAdFooterSocialMediaLink(props) { //props: p_text, p_href
  const p_text = props.p_text;
  const p_href = props.p_href;

  return(
    <div className="" style={{paddingBottom:"4px"}}>
      <a href={p_href} target="_blank" rel="noreferrer" className="font14 fontDarkGrayBlueSamGovTracker cursorPointer" style={{textDecoration:"none"}}>
        <font className="hoverFontUnderline">{p_text}</font>
      </a>
    </div>
  );
}

const SGTAdProductActionButton = inject("CaptureExecMobx")(observer(
class SGTAdProductActionButton extends Component { //props: p_product, p_buttonText
  onclick_product_action_button = () => {
    const p_product = this.props.p_product;

    if(p_product === "samgovtracker") {
      this.props.CaptureExecMobx.a_set_login_state("sgtBuySgtEnterInfo");
    }
    else if(p_product === "captureexec") {
      window.open("https://bitsolutionsllc.com/capture-exec/captureexec-capture-executive-software/", "_blank");
      //this.props.CaptureExecMobx.a_set_login_state("sgtCaptureExecLearnMoreAd"); //TODO actually implement this CE ad
    }
  }

  render() {
    const p_product = this.props.p_product;
    const p_buttonText = this.props.p_buttonText;
    const buttonBackground = (p_product === "samgovtracker") ? "#0968a8" : "#1b3155";

    return(
      <button
        type="button"
        className="displayFlexColumnHcVc textCenter cursorPointer"
        style={{width:"100%", height:"3.5em", border:0, borderRadius:"8px", background:buttonBackground, color:"#fff", fontSize:"0.94rem", fontWeight:"800", cursor:"pointer"}}
        onClick={this.onclick_product_action_button}>
        {p_buttonText}
      </button>
    );
  }
} ));

function SGTAdProductBoxBulletList({p_bulletsTextArray, p_fontClass}) {
  return(
    <div className="flex11a" style={{flexBasis:"100em"}}>
      {p_bulletsTextArray.map((m_bulletText) =>
        <div key={m_bulletText} className={"displayFlexRow " + p_fontClass} style={{marginBottom:"0.9em"}}>
          <div className="flex00a" style={{flexBasis:"1.1em"}}>
            <font className="font11 fontDarkGrayBlueSamGovTracker">
              {"\u2022"}
            </font>
          </div>
          <div className="flex11a">
            <font className="font11">
              {m_bulletText}
            </font>
          </div>
        </div>
      )}
    </div>
  );
}

const SGTAdHatPicture = inject("CaptureExecMobx")(observer(
class SGTAdHatPicture extends Component { //props: 
  render() {
    return(
      <div className="flex00a" style={{width:"100%", maxWidth:"540px"}}>
        <img
          src="https://bitsolutionsllc.com/wp-content/uploads/2026/05/Making-SAM.gov-work-for-you.webp"
          alt="SAM Gov Tracker organizes the capture work SAM.gov does not manage"
          style={{display:"block", width:"100%", height:"auto"}}
        />
      </div>
    );
  }
} ));

function SGTAdLRScreenshotAndTagline(props) { //props: p_horizontalTrueVerticalFalse, p_screenshotLeftTrueRightFalse, p_screenshotSrc, p_screenshotAlt, p_taglineTitle, p_taglineBulletsTextArray
  const p_horizontalTrueVerticalFalse = props.p_horizontalTrueVerticalFalse;
  const p_screenshotLeftTrueRightFalse = props.p_screenshotLeftTrueRightFalse;
  const p_screenshotSrc = props.p_screenshotSrc;
  const p_screenshotMaxWidth = props.p_screenshotMaxWidth || "1500px";
  const p_screenshotAlt = props.p_screenshotAlt;
  const p_taglineTitle = props.p_taglineTitle;
  const p_taglineBulletsTextArray = props.p_taglineBulletsTextArray;

  const screenshotComponent = (
    <LibraryReact.Image
      p_src={p_screenshotSrc}
      p_alt={p_screenshotAlt}
      p_styleObj={{width:"100%", maxWidth:p_screenshotMaxWidth, height:"auto"}}
    />
  );

  const textComponent = (
    <>
      <div className="flex00a textCenter">
        <font className="font25 fontBold">
          {p_taglineTitle}
        </font>
      </div>
      <div className="medTopMargin" />
      {p_taglineBulletsTextArray.map((m_taglineBulletText, m_index) =>
        <div
          key={m_index}
          className="flex00a textCenter">
          <font className="font18">
            {m_taglineBulletText}
          </font>
        </div>
      )}
    </>
  );

  if(p_horizontalTrueVerticalFalse) {
    const screenshotSideComponent = (
      <div className="flex11a" style={{flexBasis:"150em", padding:"4em"}}>
        <div style={{boxShadow:"0.5em 0.5em 1em #394853"}}>
          {screenshotComponent}
        </div>
      </div>
    );

    const textSideComponent = (
      <div className="flex11a displayFlexColumnHcVc" style={{flexBasis:"100em"}}>
        {textComponent}
      </div>
    );

    return(
      <div className="displayFlexRow">
        {(p_screenshotLeftTrueRightFalse) ? (
          <>{screenshotSideComponent}{textSideComponent}</>
        ) : (
          <>{textSideComponent}{screenshotSideComponent}</>
        )}
      </div>
    );
  }

  return(
    <div style={{padding:"5%"}}>
      <div className="displayFlexColumnHcVc">
        {textComponent}
        <div className="hugeTopMargin" />
        {screenshotComponent}
      </div>
    </div>
  );
}

function SGTAdFooterLabel(props) { //props: children
  return(
    <div style={{paddingBottom:"5px"}}>
      <font className="font16 fontBold fontDarkGrayBlueSamGovTracker">
        {props.children}
      </font>
    </div>
  );
}

class SGTAdFooterQuickLink extends Component { //props: p_text, p_scrollToElementID, f_onClick
  onclick_quick_link_page_scroll = () => {
    const p_scrollToElementID = this.props.p_scrollToElementID;

    const depthOfParentsToCheck = 2;
    document.getElementById(p_scrollToElementID).scrollIntoViewIfNeeded(depthOfParentsToCheck);
  }

  render() {
    const p_text = this.props.p_text;
    const f_onClick = this.props.f_onClick;

    return(
      <div className="displayFlexRow" style={{paddingBottom:"2px"}}>
        <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"2em"}}>
          <font className="font16 fontDarkGrayBlueSamGovTracker">
            {"\u2022"}
          </font>
        </div>
        <div
          className="flex11a displayFlexColumnVc hoverFontUnderline cursorPointer"
          onClick={((f_onClick !== undefined) ? (f_onClick) : (this.onclick_quick_link_page_scroll))}>
          <font className="font14 fontDarkGrayBlueSamGovTracker ">
            {p_text}
          </font>
        </div>
      </div>
    );
  }
}




//^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
//^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
const SGTBuyBackToHomeLink = inject("CaptureExecMobx")(observer(
class SGTBuyBackToHomeLink extends Component {
  onclick_go_back = () => {
    this.props.CaptureExecMobx.a_set_login_state("out");
  }

  render() {
    return(
      <div
        className="displayFlexRowVc cursorPointer"
        title="Return to the samgovtracker.com homepage"
        onClick={this.onclick_go_back}>
        <div className="flex00a" style={{marginRight:"0.7em"}}>
          <font className="font25 fontBold fontAlmostWhite">{"\u2190"}</font>
        </div>
        <div className="flex00a hoverFontUnderline">
          <font className="font16 fontAlmostWhite">
            {"Back to Home"}
          </font>
        </div>
      </div>
    );
  }
}));



const BuySGTCustomerInfoFormContents = inject("CaptureExecMobx", "SamGovTrackerMobx")(observer(
class BuySGTCustomerInfoFormContents extends Component {
  onchange_customer_company_name = (i_newValueString) => {
    this.props.SamGovTrackerMobx.a_set_customer_company_name(i_newValueString);
  }

  onchange_sgt_company_code = (i_newValueString) => {
    const updatedCompanyCodeNoSpecialChars = i_newValueString.replace(/[^a-zA-Z0-9]/g, ""); //remove all characters except A-Z and 0-9
    this.props.SamGovTrackerMobx.a_set_customer_company_code(updatedCompanyCodeNoSpecialChars);
  }

  onchange_sgt_firstname = (i_newValueString) => {
    this.props.SamGovTrackerMobx.a_set_customer_first_name(i_newValueString);
  }

  onchange_sgt_lastname = (i_newValueString) => {
    this.props.SamGovTrackerMobx.a_set_customer_last_name(i_newValueString);
  }

  onchange_sgt_email = (i_newValueString) => {
    this.props.SamGovTrackerMobx.a_set_customer_email(i_newValueString);
  }

  onchange_sgt_num_users = (i_newValueInt) => {
    this.props.SamGovTrackerMobx.a_set_purchase_sgt_num_users(i_newValueInt);
  }

  onclick_product_sgt_no_docs = () => {
    this.props.SamGovTrackerMobx.a_set_purchase_sgt_product("sgtNoDocs");
  }

  onclick_product_sgt_with_docs = () => {
    this.props.SamGovTrackerMobx.a_set_purchase_sgt_product("sgtWithDocs");
  }

  onclick_continue_button_with_errors = () => {
    this.props.SamGovTrackerMobx.a_set_next_button_pushed_at_least_once_tf(true);
  }

  onclick_continue_button_no_errors = () => {
    this.props.SamGovTrackerMobx.a_set_buy_process_state("cc");
    this.props.SamGovTrackerMobx.a_set_next_button_pushed_at_least_once_tf(true);
  }

  onclick_reedit_button = () => {
    this.props.SamGovTrackerMobx.a_set_buy_process_state("info");
  }

  render() {
    const k_maxNumUsersAvailableToSelect = this.props.SamGovTrackerMobx.k_maxNumUsersAvailableToSelect;
    const o_customerCompanyName = this.props.SamGovTrackerMobx.o_customerCompanyName;
    const o_customerCompanyCode = this.props.SamGovTrackerMobx.o_customerCompanyCode;
    const o_customerFirstName = this.props.SamGovTrackerMobx.o_customerFirstName;
    const o_customerLastName = this.props.SamGovTrackerMobx.o_customerLastName;
    const o_customerEmail = this.props.SamGovTrackerMobx.o_customerEmail;
    const o_purchaseSGTNumUsers = this.props.SamGovTrackerMobx.o_purchaseSGTNumUsers;
    const c_buyProcessStateIsInfoTF = this.props.SamGovTrackerMobx.c_buyProcessStateIsInfoTF;
    const c_buyProcessStateIsCCTF = this.props.SamGovTrackerMobx.c_buyProcessStateIsCCTF;
    const c_customerCompanyNameErrorMessageObj = this.props.SamGovTrackerMobx.c_customerCompanyNameErrorMessageObj;
    const c_customerCompanyCodeErrorMessageObj = this.props.SamGovTrackerMobx.c_customerCompanyCodeErrorMessageObj;
    const c_customerFirstNameErrorMessageObj = this.props.SamGovTrackerMobx.c_customerFirstNameErrorMessageObj;
    const c_customerLastNameErrorMessageObj = this.props.SamGovTrackerMobx.c_customerLastNameErrorMessageObj;
    const c_customerEmailErrorMessageObj = this.props.SamGovTrackerMobx.c_customerEmailErrorMessageObj;
    const c_selectSgtProductNumUsersFieldTypeObj = this.props.SamGovTrackerMobx.c_selectSgtProductNumUsersFieldTypeObj;
    const c_selectedNumUsersValueMask = this.props.SamGovTrackerMobx.c_selectedNumUsersValueMask;
    const c_selectedProductSgtNoDocsTF = this.props.SamGovTrackerMobx.c_selectedProductSgtNoDocsTF;
    const c_selectedProductSgtWithDocsTF = this.props.SamGovTrackerMobx.c_selectedProductSgtWithDocsTF;
    const c_selectedSgtProductPriceAmount = this.props.SamGovTrackerMobx.c_selectedSgtProductPriceAmount;
    const c_selectedSgtProductTotalPayFormattedPrice = this.props.SamGovTrackerMobx.c_selectedSgtProductTotalPayFormattedPrice;
    const c_priceIncreasePerUserForWithDocsFormattedPrice = this.props.SamGovTrackerMobx.c_priceIncreasePerUserForWithDocsFormattedPrice;
    const c_companyInfoFormCanContinueNoErrorsTF = this.props.SamGovTrackerMobx.c_companyInfoFormCanContinueNoErrorsTF;
    const c_computedUrlAndProductObj = this.props.CaptureExecMobx.c_computedUrlAndProductObj;
    const c_productStylingObj = this.props.CaptureExecMobx.c_productStylingObj;

    const fieldSpacingEm = 2;

    var companyNameHoverText = undefined;

    var companyCodeHoverText = "For example, the company 'BIT Solutions' might pick 'BIT' or 'bitsolu' for their company code.";
    companyCodeHoverText += "\nYour team will use this code along with their email address and password to log in.";
    companyCodeHoverText += "\nThis is not case sensitive, however no spaces or special characters are allowed.";

    var yourNameHoverText = "This will be the name of the first Admin in the system that can then add all other Users.";

    var yourEmailHoverText = undefined;

    var numUsersHoverText = "This can always be increased later and decreased at any time.";
    numUsersHoverText += "\nYou will be the first User as an Admin, and can create/assign new Users.";
    numUsersHoverText += "\nFor companies with more than " + k_maxNumUsersAvailableToSelect + " system Users, we recommend our executive CaptureExec product.";

    var productSGTNoDocsHoverText = "In our standard SAM Gov Tracker system, imported SAM.gov Captures include a field for opportunity related documents provided by the government that are hosted on and can be downloaded from SAM.";
    productSGTNoDocsHoverText += "\nIf additionally you would like to upload, share, and manage your local capture/strategy/proposal documents within SAM Gov Tracker, you can select our upgraded 'with unlimited File Storage' option.";

    var productSGTWithDocsHoverText = "Optional " + c_priceIncreasePerUserForWithDocsFormattedPrice + "/user upgrade adds the 'Documents' card to your created and imported Captures.";
    productSGTWithDocsHoverText += "\nEasily manage your documents in one place using SGT's secure cloud storage for file uploads and organization.";

    return(
      <>
        <div className="displayFlexRow" style={{height:"45px"}}>
          <div className="flex00a">
            <LibraryReact.Image p_src={c_computedUrlAndProductObj.productGraphicsSubfolderAddress + "/samgovtracker13.png"} p_alt={c_productStylingObj.productName} />
          </div>
          <div className="flex11a" />
        </div>
        <div style={{marginTop:fieldSpacingEm + "em"}} />
        <BuySGTCardTitle>{"Tell Us About Yourself"}</BuySGTCardTitle>
        <SGTCompanyInfoLabel
          p_label="Company Name"
          p_infoHoverText={companyNameHoverText}
        />
        <SGTCompanyInfoSingleInputText p_value={o_customerCompanyName} p_placeholder="Your Company, LLC" p_tabIndex={1} p_errorMessageObj={c_customerCompanyNameErrorMessageObj} p_canEditTF={c_buyProcessStateIsInfoTF} f_onChange={this.onchange_customer_company_name} />
        <div style={{marginTop:fieldSpacingEm + "em"}} />
        <SGTCompanyInfoLabel
          p_label="Choose a unique 'Company Code' for your team"
          p_infoHoverText={companyCodeHoverText}
        />
        <SGTCompanyInfoSingleInputText p_value={o_customerCompanyCode} p_placeholder="YOURCO" p_tabIndex={2} p_errorMessageObj={c_customerCompanyCodeErrorMessageObj} p_canEditTF={c_buyProcessStateIsInfoTF} f_onChange={this.onchange_sgt_company_code} />
        <div style={{marginTop:fieldSpacingEm + "em"}} />
        <SGTCompanyInfoLabel
          p_label="Your Name"
          p_infoHoverText={yourNameHoverText}
        />
        <div className="displayFlexRow">
          <div className="flex11a" style={{flexBasis:"100em"}}>
            <SGTCompanyInfoSingleInputText p_value={o_customerFirstName} p_placeholder="First Name" p_tabIndex={3} p_errorMessageObj={c_customerFirstNameErrorMessageObj} p_canEditTF={c_buyProcessStateIsInfoTF} f_onChange={this.onchange_sgt_firstname} />
          </div>
          <div className="flex00a" style={{flexBasis:"1em"}} />
          <div className="flex11a" style={{flexBasis:"125em"}}>
            <SGTCompanyInfoSingleInputText p_value={o_customerLastName} p_placeholder="Last Name" p_tabIndex={4} p_errorMessageObj={c_customerLastNameErrorMessageObj} p_canEditTF={c_buyProcessStateIsInfoTF} f_onChange={this.onchange_sgt_lastname} />
          </div>
        </div>
        <div style={{marginTop:fieldSpacingEm + "em"}} />
        <SGTCompanyInfoLabel
          p_label="Your Email Address"
          p_infoHoverText={yourEmailHoverText}
        />
        <SGTCompanyInfoSingleInputText p_value={o_customerEmail}  p_placeholder="email@yourco.com" p_tabIndex={5} p_errorMessageObj={c_customerEmailErrorMessageObj} p_canEditTF={c_buyProcessStateIsInfoTF} f_onChange={this.onchange_sgt_email} />
        <div style={{marginTop:fieldSpacingEm + "em"}} />
        <div className="displayFlexRowVc">
          <div className="flex00a" style={{flexBasis:"8em"}}>
            <SGTCompanyInfoLabel
              p_label="# Users"
              p_infoHoverText={numUsersHoverText}
            />
          </div>
          <div className="flex00a" style={{flexBasis:"10em"}}>
            {(c_buyProcessStateIsInfoTF) ? (
              <font className="font12">
                <CEGeneralReact.GenericInputOrSelectFromInputType
                  p_fieldTypeObj={c_selectSgtProductNumUsersFieldTypeObj}
                  p_valueRaw={o_purchaseSGTNumUsers}
                  p_selectDisplayMaskOverwrite={c_selectedNumUsersValueMask}
                  p_tabIndex={6}
                  f_onChangeOrOnSelect={this.onchange_sgt_num_users}
                />
              </font>
            ) : (
              <div className="tbMargin">
                <font className="font12">
                  {c_selectedNumUsersValueMask}
                </font>
              </div>
            )}
          </div>
          <div className="flex11a" />
        </div>
        {(c_selectedSgtProductPriceAmount >= 0) &&
          <>
            <div className="bigTopMargin" />
            <SGTProductButton
              p_isSelectedTF={c_selectedProductSgtNoDocsTF}
              p_productText={o_purchaseSGTNumUsers + " standard SAM Gov Tracker " + JSFUNC.plural(o_purchaseSGTNumUsers, "License", "Licenses")}
              p_infoHoverText={productSGTNoDocsHoverText}
              p_canEditTF={c_buyProcessStateIsInfoTF}
              f_onClick={this.onclick_product_sgt_no_docs}
            />
            <SGTProductButton
              p_isSelectedTF={c_selectedProductSgtWithDocsTF}
              p_productText={(<>{o_purchaseSGTNumUsers + " SAM Gov Tracker " + JSFUNC.plural(o_purchaseSGTNumUsers, "License", "Licenses")}<font className="fontBold">{" with unlimited File Storage"}</font></>)}
              p_infoHoverText={productSGTWithDocsHoverText}
              p_canEditTF={c_buyProcessStateIsInfoTF}
              f_onClick={this.onclick_product_sgt_with_docs}
            />
            <div className="bigTopMargin">
              <font className="font35 fontBold fontDarkGrayBlueSamGovTracker">
                {c_selectedSgtProductTotalPayFormattedPrice + " / mo"}
              </font>
            </div>
          </>
        }
        <div className="bigTopMargin" />
        {(c_buyProcessStateIsCCTF) ? (
          <SGTBuyActionButton
            p_buttonType="hollow"
            p_buttonText="Re-edit Info"
            f_onClick={this.onclick_reedit_button}
          />
        ) : (
          <>
            <SGTBuyActionButton
              p_buttonType="solid"
              p_buttonText="Next"
              f_onClick={((c_companyInfoFormCanContinueNoErrorsTF) ? (this.onclick_continue_button_no_errors) : (this.onclick_continue_button_with_errors))}
            />
            <div className="bigTopMargin">
              <font className="font11 fontDarkGrayBlueSamGovTracker">
                {"Cancel anytime. No binding contracts."}
              </font>
            </div>
          </>
        )}
      </>
    );
  }
}));




const BuySGTCardTitle = inject("CaptureExecMobx")(observer(
class BuySGTCardTitle extends Component { //props: children
  render() {
    const c_isMobileTF = this.props.CaptureExecMobx.c_isMobileTF;

    return(
      <div className="bigBottomMargin">
        <font className={((c_isMobileTF) ? ("font22") : ("font25")) + " fontBold fontDarkGrayBlueSamGovTracker"}>
          {this.props.children}
        </font>
      </div>
    );
  }
}));


const SGTCompanyInfoLabel = inject("CaptureExecMobx")(observer(
class SGTCompanyInfoLabel extends Component { //props: p_label, p_infoHoverText
  render() {
    const p_label = this.props.p_label;
    const p_infoHoverText = this.props.p_infoHoverText;

    const c_isMobileTF = this.props.CaptureExecMobx.c_isMobileTF;

    return(
      <div className="displayFlexRow" style={{marginBottom:"0.25em"}}>
        <div className="flex00a">
          <font className={((c_isMobileTF) ? ("font13") : ("font16")) + " fontTextLighter"}>
            {p_label}
          </font>
        </div>
        {(p_infoHoverText !== undefined) &&
          <SGTCompanyInfoHelpIconWithHoverText p_infoHoverText={p_infoHoverText} />
        }
      </div>
    );
  }
}));


function SGTCompanyInfoHelpIconWithHoverText(props) { //props: p_infoHoverText
  const p_infoHoverText = props.p_infoHoverText;

  return(
    <div
      className="flex00a displayFlexColumn cursorHelp"
      style={{padding:"0 0.25em"}}
      title={p_infoHoverText}>
      <div className="flex00a displayFlexColumnHcVc border1bbb textCenter" style={{width:"1.1em", height:"1.1em", borderRadius:"0.3em", background:"#fcfcfc"}}>
        <font className="fontBold fontBlue">
          {"i"}
        </font>
      </div>
      <div className="flex11a" />
    </div>
  );
}

function SGTCompanyInfoSingleInputText(props) { //p_value, p_placeholder, p_tabIndex, p_errorMessageObj, p_canEditTF, f_onChange
  const p_value = props.p_value;
  const p_placeholder = props.p_placeholder;
  const p_tabIndex = props.p_tabIndex;
  const p_errorMessageObj = props.p_errorMessageObj;
  const p_canEditTF = props.p_canEditTF;

  if(p_errorMessageObj === undefined) {
    return(<div className="medFullPad bgRed" />)
  }

  const errorTF = (p_errorMessageObj.showErrorMessageTF && (p_errorMessageObj.errorMessageOrUndefined !== undefined));

  if(!p_canEditTF) {
    return(
      <div className="border1bbb borderRadius05 bgLightestGray" style={{width:"100%", padding:"0.4em 0.75em"}}>
        <font className="font15 fontTextLight">
          {p_value}
        </font>
      </div>
    );
  }

  return(
    <>
      <LibraryReact.Text
        p_value={p_value}
        p_isPasswordTF={false}
        p_class="border1bbb  font15"
        p_styleObj={{width:"100%", padding:"0.4em 0.75em"}}
        p_tabIndex={p_tabIndex}
        p_placeholder={p_placeholder}
        p_errorTF={errorTF}
        f_onChange={props.f_onChange}
      />
      {(errorTF) &&
        <div className="smallTopMargin">
          <font className="font11 fontItalic fontRed">
            {p_errorMessageObj.errorMessageOrUndefined}
          </font>
        </div>
      }
    </>
  );
}

function SGTProductButton(props) { //props: p_isSelectedTF, p_productText, p_infoHoverText, p_canEditTF, f_onClick
  const p_isSelectedTF = props.p_isSelectedTF;
  const p_productText = props.p_productText;
  const p_infoHoverText = props.p_infoHoverText;
  const p_canEditTF = props.p_canEditTF;

  const canSelectTF = (p_canEditTF && !p_isSelectedTF);

  return(
    <div className="displayFlexRowVc tbPad">
      <div
        className={"flex00a displayFlexColumnHcVc " + ((canSelectTF) ? ("cursorPointer") : (""))}
        style={{paddingRight:"0.9em"}}
        onClick={((canSelectTF) ? (props.f_onClick) : (undefined))}>
        <div className="flex00a displayFlexColumnHcVc" style={{width:"1.5em", height:"1.5em", border:"solid 2px #394853", borderRadius:"1em"}}>
          {(p_isSelectedTF) &&
            <div className={"flex00a " + ((p_canEditTF) ? ("bgDarkRedSamGovTracker") : ("bgDarkGray"))} style={{width:"1em", height:"1em", borderRadius:"1em"}} />
          }
        </div>
      </div>
      <div className="flex11a displayFlexRow">
        <div className="flex00a">
          <font className="font13 fontDarkGrayBlueSamGovTracker">
            {p_productText}
          </font>
        </div>
        {(p_infoHoverText !== undefined) &&
          <SGTCompanyInfoHelpIconWithHoverText p_infoHoverText={p_infoHoverText} />
        }
      </div>
    </div>
  );
}



//^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
//^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
function SGTBuyActionButton(props) { //props: p_buttonType, p_buttonText, f_onClick
  const p_buttonType = props.p_buttonType; //"solid", "hollow"
  const p_buttonText = props.p_buttonText;

  var buttonClass = "border bevelBorderColors bgRedGradientSamGovTracker hoverLightRedGradientSamGovTracker";
  var fontClass = "fontBold fontWhite";
  if(p_buttonType === "hollow") {
    fontClass = "fontDarkRedSamGovTracker";
    buttonClass = "border1DarkRedSamGovTracker bgAlmostWhite";
  }

  return(
    <div
      className={"flex00a displayFlexColumnHcVc borderRadius05 " + buttonClass + " textCenter cursorPointer"}
      style={{width:"20em", height:"4em"}}
      onClick={props.f_onClick}>
      <font className={"font15 " + fontClass}>
        {p_buttonText}
      </font>
    </div>
  );
}



const SGTAdTestimonialsCarousel = inject("CaptureExecMobx")(observer(
class SGTAdTestimonialsCarousel extends Component { //props: p_testimonialsArrayOfObjs, p_numTestimonialsDisplayed
  constructor(props) {
    super(props);
    this.state = {
      s_testimonialCarouselIndex: 0,
      s_carouselAutomatedTrueManualFalse: true
    };
  }

  componentDidMount() {
    this.timerID = setInterval(() => this.auto_increment_testimonial_index(), 30000);
  }

  componentWillUnmount() {
    clearInterval(this.timerID);
  }

  increment_testimonial_index = () => {
    const s_testimonialCarouselIndex = this.state.s_testimonialCarouselIndex;
    const p_testimonialsArrayOfObjs = this.props.p_testimonialsArrayOfObjs;
    if(JSFUNC.is_array(p_testimonialsArrayOfObjs)) {
      const numTestimonials = p_testimonialsArrayOfObjs.length;
      if(numTestimonials > 0) {
        var updatedIndex = (s_testimonialCarouselIndex + 1);
        if(updatedIndex >= numTestimonials) {
          updatedIndex = 0;
        }
        this.setState({s_testimonialCarouselIndex:updatedIndex});
      }
    }
  }

  decrement_testimonial_index = () => {
    const s_testimonialCarouselIndex = this.state.s_testimonialCarouselIndex;
    const p_testimonialsArrayOfObjs = this.props.p_testimonialsArrayOfObjs;
    if(JSFUNC.is_array(p_testimonialsArrayOfObjs)) {
      const numTestimonials = p_testimonialsArrayOfObjs.length;
      if(numTestimonials > 0) {
        var updatedIndex = (s_testimonialCarouselIndex - 1);
        if(updatedIndex < 0) {
          updatedIndex = (numTestimonials - 1);
        }
        this.setState({s_testimonialCarouselIndex:updatedIndex});
      }
    }
  }

  auto_increment_testimonial_index = () => {
    const s_carouselAutomatedTrueManualFalse = this.state.s_carouselAutomatedTrueManualFalse;
    if(s_carouselAutomatedTrueManualFalse) {
      this.increment_testimonial_index();
    }
  }

  onclick_manual_increment_testimonial = () => {
    this.setState({s_carouselAutomatedTrueManualFalse:false});
    this.increment_testimonial_index();
  }

  onclick_manual_decrement_testimonial = () => {
    this.setState({s_carouselAutomatedTrueManualFalse:false});
    this.decrement_testimonial_index();
  }

  onclick_manual_testimonial_from_index = (i_selectedIndex) => {
    this.setState({
      s_testimonialCarouselIndex: i_selectedIndex,
      s_carouselAutomatedTrueManualFalse: false
    });
  }

  render() {
    const s_testimonialCarouselIndex = this.state.s_testimonialCarouselIndex;

    const p_testimonialsArrayOfObjs = this.props.p_testimonialsArrayOfObjs;
    const p_numTestimonialsDisplayed = this.props.p_numTestimonialsDisplayed;

    if(!JSFUNC.is_array(p_testimonialsArrayOfObjs)) {
      return(null);
    }

    const numTestimonials = p_testimonialsArrayOfObjs.length;
    if(numTestimonials === 0) {
      return(null);
    }

    if(s_testimonialCarouselIndex >= numTestimonials) {
      return(null);
    }

    var testimonialsDisplayedComponent = null;
    if(p_numTestimonialsDisplayed === 1) {
      const testimonialObj = p_testimonialsArrayOfObjs[s_testimonialCarouselIndex];
      testimonialsDisplayedComponent = (<SGTAdSingleTestimonial key={testimonialObj.id} p_testimonialObj={testimonialObj} />);
    }
    else if(p_numTestimonialsDisplayed === 3) {
      var leftIndex = (s_testimonialCarouselIndex - 1);
      if(leftIndex < 0) {
        leftIndex = (numTestimonials - 1);
      }

      var rightIndex = (s_testimonialCarouselIndex + 1);
      if(rightIndex >= numTestimonials) {
        rightIndex = 0;
      }

      const leftTestimonialObj = p_testimonialsArrayOfObjs[leftIndex];
      const centerTestimonialObj = p_testimonialsArrayOfObjs[s_testimonialCarouselIndex];
      const rightTestimonialObj = p_testimonialsArrayOfObjs[rightIndex];

      testimonialsDisplayedComponent = (
        <div className="displayFlexRow">
          <div className="flex00a" style={{flexBasis:"2em"}} />
          <div className="flex11a" style={{flexBasis:"100em"}}>
            <SGTAdSingleTestimonial key={leftTestimonialObj.id} p_testimonialObj={leftTestimonialObj} />
          </div>
          <div className="flex00a" style={{flexBasis:"2em"}} />
          <div className="flex11a" style={{flexBasis:"100em"}}>
            <SGTAdSingleTestimonial key={centerTestimonialObj.id} p_testimonialObj={centerTestimonialObj} />
          </div>
          <div className="flex00a" style={{flexBasis:"2em"}} />
          <div className="flex11a" style={{flexBasis:"100em"}}>
            <SGTAdSingleTestimonial key={rightTestimonialObj.id} p_testimonialObj={rightTestimonialObj} />
          </div>
          <div className="flex00a" style={{flexBasis:"2em"}} />
        </div>
      );
    }

    return(
      <>
        {testimonialsDisplayedComponent}
        <div className="displayFlexColumnHcVc smallTopMargin">
          <div className="displayFlexRow">
            <div
              className="flex00a displayFlexColumnHcVc textCenter cursorPointer"
              style={{width:"3em"}}
              title="View Previous Testimonial"
              onClick={this.onclick_manual_decrement_testimonial}>
              <font className="font20 fontAlmostWhite">
                {"\u25c0"}
              </font>
            </div>
            {p_testimonialsArrayOfObjs.map((m_testimonialObj, m_index) =>
              <div
                className="flex00a displayFlexColumnHcVc textCenter cursorPointer"
                style={{width:"1.6em"}}
                title={"View Testimonial #" + (m_index + 1) + " from " + m_testimonialObj.company_name}
                onClick={() => {this.onclick_manual_testimonial_from_index(m_index); }}>
                <div
                  className={"border1ddd borderRadius10 " + ((s_testimonialCarouselIndex === m_index) ? ("bgDarkRedSamGovTracker") : ("bgAlmostWhite"))}
                  style={{width:"0.6em", height:"0.6em"}}
                />
              </div>
            )}
            <div
              className="flex00a displayFlexColumnHcVc textCenter cursorPointer"
              style={{width:"3em"}}
              title="View Next Testimonial"
              onClick={this.onclick_manual_increment_testimonial}>
              <font className="font18 fontAlmostWhite">
                {"\u25b6"}
              </font>
            </div>
          </div>
        </div>
      </>
    );
  }
}));


const SGTAdSingleTestimonial = inject("CaptureExecMobx")(observer(
class SGTAdSingleTestimonial extends Component {//props: p_testimonialObj
  render() {
    const p_testimonialObj = this.props.p_testimonialObj;

    const c_computedUrlAndProductObj = this.props.CaptureExecMobx.c_computedUrlAndProductObj;

    const carouselQuoteHeightEm = 15;

    var productLogoFileNameAndExt = "captureexec8.png";
    if(p_testimonialObj.calcProduct === "samgovtracker") {
      productLogoFileNameAndExt = "samgovtracker8.png";
    }

    return(
      <div className="animationSlideLeft border1bbb borderRadius10 bgWhite hugeFullPad">
        <div className="" style={{height:"52px"}}>
          <LibraryReact.Image p_src={c_computedUrlAndProductObj.productGraphicsSubfolderAddress + "/testimonial_logo50px_" + p_testimonialObj.company_code + ".png"} p_alt={p_testimonialObj.company_name} />
        </div>
        <div className="tbBigPad">
          <div className="" style={{height:carouselQuoteHeightEm + "em"}}>
            <LibraryReact.MaxHeightWrap p_maxHeight={carouselQuoteHeightEm + "em"} p_fontClass="font12 fontTextLight">
              {'"' + p_testimonialObj.quote_text + '"'}
            </LibraryReact.MaxHeightWrap>
          </div>
        </div>
        <div className="" style={{height:"2em"}}>
          <font className="font18 fontBold fontDarkGrayBlueSamGovTracker">
            {p_testimonialObj.user_full_name}
          </font>
        </div>
        <div className="bigTopMargin" />
        <div className="" style={{height:"1.6em"}}>
          <LibraryReact.NowrapEllipsis p_fontClass="font14 fontBold fontDarkGrayBlueSamGovTracker">
            {p_testimonialObj.company_name}
          </LibraryReact.NowrapEllipsis>
        </div>
        <div className="" style={{height:"1.6em"}}>
          <LibraryReact.NowrapEllipsis p_fontClass="font14 fontBold fontDarkGrayBlueSamGovTracker">
            {p_testimonialObj.user_title}
          </LibraryReact.NowrapEllipsis>
        </div>
        <div className="bigTopMargin" />
        <div className="" style={{height:"1.8em"}}>
          <font className="font14 fontTextLight">
            {"Using"}
          </font>
        </div>
        <div className="" style={{height:"2.2em"}}>
          <LibraryReact.Image p_src={c_computedUrlAndProductObj.productGraphicsSubfolderAddress + "/" + productLogoFileNameAndExt} p_alt={p_testimonialObj.calcProduct} />
        </div>
        <div className="" style={{height:"1.8em"}}>
          <font className="font14 fontTextLight">
            {"for " + p_testimonialObj.calcUseNumYears + " " + JSFUNC.plural(p_testimonialObj.calcUseNumYears, "year", "years")}
          </font>
        </div>
      </div>
    );
  }
}));
